import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  const displayCategories = categories.slice(1, 9);

  const categoryIcons: Record<string, string> = {
    'hot-blooded': 'ri-fire-line',
    romance: 'ri-heart-line',
    fantasy: 'ri-magic-line',
    comedy: 'ri-emotion-laugh-line',
    action: 'ri-sword-line',
    horror: 'ri-ghost-line',
    'slice-of-life': 'ri-sun-line',
    scifi: 'ri-rocket-line',
    school: 'ri-book-open-line',
    adventure: 'ri-compass-3-line',
    martial: 'ri-knife-line',
  };

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            漫画分类
          </h2>
          <Link
            to="/category"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors no-underline flex items-center gap-1 whitespace-nowrap"
          >
            全部分类
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-3">
          {displayCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category?tab=${cat.slug}`}
              className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background-100 hover:bg-primary-100/60 transition-colors no-underline group cursor-pointer"
            >
              <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${categoryIcons[cat.slug] || 'ri-bookmark-line'} text-xl text-primary-500 w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <span className="text-sm text-foreground-700 group-hover:text-primary-600 font-medium whitespace-nowrap transition-colors">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}